"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var roundNumber_1 = __importDefault(require("./roundNumber"));
/**
 * Formats a given number as U.S. currency (dollars)
 *
 * @example
 * import formatCurrency from '@carvana/futilities/formatCurrency';
 * formatCurrency(20)
 * // () => '$20'
 * formatCurrency(19.30)
 * // () => '$19.30'
 *
 * @kind function
 * @name formatCurrency
 * @sig Number -> String
 * @param {Number} value The numeric value to be converted to currency
 * @returns {String} The original number formatted as U.S. currency
 */
function formatCurrency(value) {
    return "" + roundNumber_1.default(value, 2);
}
exports.default = formatCurrency;
//# sourceMappingURL=formatCurrency.js.map